import { render, staticRenderFns } from "./FeedbackRemarkTable.vue?vue&type=template&id=e43a513c&"
import script from "./FeedbackRemarkTable.vue?vue&type=script&lang=js&"
export * from "./FeedbackRemarkTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports